export default __webpack_public_path__ + "static/media/background.c431e198.png";